module.exports = __webpack_public_path__ + "static/media/pdf.974856ea.svg";